/**
 * @file 哈勃 SDK
 * @author dafo<huanghouin@baijiahulian.com>
 */
import {
    setConfig,
    initExtraData,
    setPublicParams
} from './util/config';
import click from './click';
import perf from './perf';
import scroll from './scroll';
import view from './view';
import Logger from './log';
import stay from './stay';
import video from './video';
import timing, {time, timeEnd} from './time';
import fps from './fps';
import fmp from './fmp';
import error from './error';
import startTrack from './visualTrack';

initExtraData();

startTrack();

/**
 * @name habo
 * @type {Object}
 * @property {Function} setConfig {@link module:config.setConfig}
 * @property {Function} click {@link module:module/click~report}
 * @property {Function} perf {@link module:module/perf~report}
 * @property {Function} scroll {@link module:module/scroll~report}
 * @property {Function} view {@link module:module/view~report}
 * @property {Function} stay {@link module:module/stay~report}
 * @property {Function} video {@link module:module/video~report}
 * @property {Function} timing {@link module:module/timing~report}
 * @property {Function} time {@link module:module/timing.time}
 * @property {Function} timeEnd {@link module:module/timing.timeEnd}
 */
export default {
    setConfig,
    setPublicParams,
    click,
    perf,
    scroll,
    view,
    stay,
    video,
    fps,
    fmp,
    error,
    Logger,

    timing,
    time,
    timeEnd,

    version: VERSION

};
